import styled from "styled-components";
import { SERVICE_PHONES } from "appLauncher";

const Wrapper = styled.div`
  padding-top: 74px;
  padding-bottom: 74px;
  background: #e3eefd;
`;
const Card = styled.div`
  width: 790px;
  height: 820px;
  background: #fff;
  border-radius: 10px;
  margin: 0 auto;
  box-shadow: 0 4px 24px rgba(38, 64, 237, 0.08);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
`;

const ContactRow = styled.div`
  width: 790px;
  margin: 32px auto 0 auto;
  font-size: 16px;
  color: #1b2532;
  text-align: center;
`;

const PhoneLink = styled.a`
  color: inherit;
  text-decoration: none;
  margin: 0 8px;
  cursor: pointer;
  font-weight: inherit;
`;

export default function Searched({ code }: { code: string }) {
  return (
    <Wrapper>
      <Card>
        <iframe
          src={"//search.zgjmdbw.com/" + code}
          style={{ width: "100%", height: "100%", border: "none" }}
        />
      </Card>
      <ContactRow>
        联系客服：
        <PhoneLink href={`tel:${SERVICE_PHONES[0]}`}>
          {SERVICE_PHONES[0]}
        </PhoneLink>
        <PhoneLink href={`tel:${SERVICE_PHONES[1]}`}>
          {SERVICE_PHONES[1]}
        </PhoneLink>
      </ContactRow>
    </Wrapper>
  );
}
